<script setup>
import { useI18n } from '../../i18n'
import { systemRoleName } from '../../access/labels.js'
defineProps({ roles: { type: Array, required: true }, selectedId: { type: Number, default: null } })
const emit = defineEmits(['select'])
const { t } = useI18n()
</script>

<template><aside class="access-role-list"><h2>{{ t('rolesCount', { count: roles.length }) }}</h2><button v-for="role in roles" :key="role.id" type="button" :class="{ selected: role.id === selectedId }" @click="emit('select', role)"><span><strong>{{ systemRoleName(t, role) }}</strong><small>{{ role.isSystem ? t('systemRole') : t('customRole') }}</small></span><em>{{ role.userCount }}</em></button></aside></template>
